<template>
  <div class="master-table-type">
    <el-table
      :fit="true"
      :data="result"
      v-show="isShow"
      width="100%">

      <!--  ユーザーグループ名  -->
      <el-table-column
        class-name="col-3"
        prop="userGroupName"
        :label="$t('label.system.userGroup.search.userGroupName')"
      />

      <!--  ユーザーグループID -->
      <el-table-column
        class-name="col-3"
        prop="userGroupExId"
        :label="$t('label.system.userGroup.search.userGroupID')"
      />

      <!--  メンバー名  -->
      <el-table-column
        class-name="col-3"
        :label="$t('label.system.userGroup.search.memberName')">
        <div slot-scope="scope" class="detail-button with-100">
          <div v-if="scope.row.accountList.length > 0">
            <div>
              {{ scope.row.accountList[0].fullname }}
            </div>

            <div v-if="scope.row.accountList.length > 1">
              {{ $t("label.system.userGroup.search.others" ,
                    {
                      length:scope.row.accountList.length -1
                    }) }}
            </div>
          </div>
        </div>
      </el-table-column>

      <!--  メールアドレス  -->
      <el-table-column
        class-name="col-3"
        :label="$t('label.system.userGroup.search.mailAddress')">
        <div slot-scope="scope" class="detail-button with-100">
          <div v-if="scope.row.accountList.length > 0">
            <div>
              {{ scope.row.accountList[0].email }}
            </div>
          </div>
        </div>

      </el-table-column>

      <!--  エリア  -->
      <el-table-column
        class-name="col-4"
        :label="$t('label.system.userGroup.search.area')">
        <div slot-scope="scope" class="detail-button with-100">
          <div v-for="(item , index) in scope.row.areaList" :key="index">
            {{ item.areaName}}
          </div>
        </div>
      </el-table-column>

      <!--   その他操作列   -->
      <el-table-column class-name="col-2">
        <div slot-scope="scope" class="detail-button with-100">
          <!--  照会バータン  -->
          <sp-smart-button @click="handleDetailAction(scope.row)" class="detailed-but with-100">{{$t('button.common.detail')}}</sp-smart-button>
        </div>
      </el-table-column>

      <el-table-column class-name="col-2" class="text-right">>
        <div slot-scope="scope"  class="text-center">
          <el-popconfirm
            popper-class="iot-pop-confirm"
            :title="$t('message.system.owner.deleteConfirm')"
            :confirmButtonText="$t('button.common.ok')"
            :cancelButtonText="$t('button.common.cancel')"
            class="btn-operate"
            @onConfirm="handleDeleteAction(scope.row)">
            <sp-smart-button
              class="button-width-100"
              v-if="$IsShowButFun('010704', scope.row.deleteFlag, true)"
              slot="reference">
              {{$t("button.common.data.delete")}}
            </sp-smart-button>
          </el-popconfirm>
        </div>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
const EVENT_DELETE = "om-delete";
import SpSmartButton from "@/components/common/sp-smart-button"

export default {
  name: "AccountSearchResultBeautify",
  components: {
    SpSmartButton: SpSmartButton
  },
  props: {
    result: Array,
    isShow: Boolean,
  },
  data() {
    return {
      value: "10件",
      options: [
        {
          label: "10件",
          value: 10,
        },
        {
          label: "20件",
          value: 20,
        },
        {
          label: "50件",
          value: 50,
        },
      ],
    };
  },
  methods: {
    handleDetailAction(row) {
      this.$router.push({
        name: "system-user-group-detail",
        params: {
          userGroupId: row.userGroupId,
        },
      });
    },

    handleDeleteAction(row) {
      this.$emit(EVENT_DELETE, row.userGroupId);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .detail-button{
  button {
    width: 100%;
  }
}
.label-right {
  position: relative;
  top: 4px;
  right: 10px;
  font-size: 16px;
}
.topthestyle {
  float: right;
  margin-bottom: 30px;
}
::v-deep .Operatingarea {
  .my-button {
    width: 134px;
    height: 40px;
    margin-left: 5px;
  }
}
.ColorChange {
  font-size: 14px;
  margin-left: 20px;
  margin-right: 13px;
  color: #6b6b69 !important;
}
::v-deep .zdyselect {
  width: 120px !important;
  font-size: 15px;
  height: 40px !important;
  border-radius: 10px !important;
  box-shadow: -2px -2px 4px #fff,
    4px 4px 4px #e6e6e1;
  .el-input__inner {
    height: 40px !important;
    border-radius: 10px !important;
    background-color: #f2f2ed !important;
    border: 0;
    color: #525250 !important;
  }
  .el-input__suffix {
    top: 0px;
    .el-input__icon {
      line-height: 25px !important;
      color: #c0c4cc;
    }
  }
}

</style>
